import { registerPlugin } from '@capacitor/core'

interface AuthenticateOptions {
	initUrl: string
	scheme?: string
}

interface AuthenticateResult {
	callbackUrl: string
}

interface AuthPluginInterface {
	authenticate(options: AuthenticateOptions): Promise<AuthenticateResult>
}

const AuthPlugin = registerPlugin<AuthPluginInterface>('AuthPlugin')

export default AuthPlugin